/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import React from "react";

type Props = {
  iconColor: string;
  onClick: () => void;
};

export const HeaderLoginButton: React.FC<Props> = (props) => {
  const styles = headerLoginButtonStyles(props.iconColor);

  return (
    <button
      id="login"
      type="button"
      aria-label="Login"
      css={styles.button}
      onClick={props.onClick}
    >
      <ExitToAppIcon />
    </button>
  );
};

const headerLoginButtonStyles = (iconColor: string) => {
  return {
    button: css({
      background: "none",
      border: "none",
      padding: 0,
      cursor: "pointer",
      svg: {
        fill: iconColor,
        cursor: "pointer",
      },
    }),
  };
};
